export default "__VITE_ASSET__D4yA8oo7__"